import React from 'react';
import IDSDescriptionList from '../IDSDescriptionList';
import IDSBadge from '../IDSBadge';
import classNames from 'classnames';

const CollectionPageFooter = ({
  footer,
  translations,
  isRegional,
  isLast,
  hasBottomContent,
}) => {
  const classNameColumn = 'c-collectionpagefooter__column';
  const footerData = createFooterData(footer, isRegional);

  const footerSection = classNames({
    'c-collectionpagefooter': true,
    'c-collectionpagefooter__last': isLast && !hasBottomContent,
    'c-collectionpagefooter__last_with_content': isLast && hasBottomContent,
  });

  return (
    <div className={footerSection}>
      <div className="c-collectionpagefooter__wrapper">
        <div className="c-collectionpagefooter__content">
          {isRegional && (
            <div className="c-collectionpagefooter__badge">
              <IDSBadge
                type={'secondary'}
                text={translations.regionlabel + ' ' + footer.Region}
              />
            </div>
          )}

          {footer && (
            <>
              {footerData?.ReviewDate && (
                <LastReviewDate
                  label={translations.revisiondate}
                  date={footerData.ReviewDate}
                  className={classNameColumn}
                />
              )}

              {footerData &&
                footerData?.NumOfRoles > 0 &&
                footerData?.Roles?.map((role, index) => {
                  return (
                    <ListColumn
                      key={index}
                      list={[role]}
                      columnClass={classNameColumn}
                    />
                  );
                })}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const LastReviewDate = ({ label, date, className }) => {
  const item = [
    {
      Term: label,
      DescriptionItems: [date, ''],
    },
  ];

  return <ListColumn list={item} columnClass={className} />;
};

const createFooterData = (footer, isRegional) => {
  const data = {
    ReviewDate: null,
    NumOfRoles: null,
    IsRegional: isRegional,
    RegionName: null,
    Roles: [], // Roles : [{Term: "Rollnamn", DescriptionItems: ['','']}]
  };

  if (footer) {
    data.ReviewDate = footer.LastReview ? footer.LastReview : '';
    data.RegionName = footer.Region ? footer.Region : '';

    data.Roles = (footer.RoleGroups ?? [])
      .filter((roleGroup) => roleGroup?.Persons?.length)
      .map((roleGroup) => ({
        Term: roleGroup.Label,
        DescriptionItems: roleGroup.Persons.map(
          ({ FirstName, LastName, Workplace, City }) =>
            [FirstName, LastName, Workplace, City].filter(Boolean).join(' ')
        ),
      }));

    data.NumOfRoles = data.Roles?.length ? data.Roles?.length : 0;
  }

  return data;
};

const ListColumn = ({ list, columnClass }) => {
  if (list && list.length <= 0) {
    return null;
  }

  return (
    <div className={columnClass}>
      <IDSDescriptionList list={list} useColumnView={false} />
    </div>
  );
};

export default CollectionPageFooter;
